import { createContext, useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ContextOperation } from "../../context/OperationContext";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import { AutoCompleteOption } from "../common/AutoComplete";
import Manipulate from "./AutocompleteManipulateValues";

interface IContextTransfer {
  getAllLocation: AutoCompleteOption[];
  reason: AutoCompleteOption[];
}

export const TransferContext = createContext<IContextTransfer>({
  getAllLocation: [],
  reason: [],
});

const TransferProvider = (props: any) => {
  const manipulate = Manipulate();
  const { i18n } = useTranslation();
  const { tenant } = useContext(ContextOperation);
  const t = useOperationTranslation();
  const [getAllLocation, setAllLocation] = useState<AutoCompleteOption[]>([]);
  const [reason, setReason] = useState<AutoCompleteOption[]>([]);

  useEffect(() => {
    manipulate
      .getLocationsByFilters({
        tenant: tenant,
        pageNumber: 0,
        pageSize: 1000000,
      })
      .then((response) => {
        setAllLocation(response);
      });

    manipulate
      .getAllReason({ tenant: tenant, includeSpecialCodes: true, ddt: true })
      .then((response) => setReason(response));
  }, [tenant, i18n.language]);

  return (
    <TransferContext.Provider value={{ getAllLocation, reason }}>
      {props.children}
    </TransferContext.Provider>
  );
};

export default TransferProvider;
